module.exports = __webpack_public_path__ + "media/error.2e337cc3.svg";